import { Button, FixedFooter, InfoCard } from "@/components";
import { ButtonContainerStyled, CamposContainer } from "./style";
import { useCampos } from "./useCampos";

export function Campos() {
  const { labels, values, handleApplyData } = useCampos();

  return (
    <CamposContainer>
      {labels.length === 0 ? (
        <p>Nenhum campo vinculado. Configure os campos na Home.</p>
      ) : (
        <InfoCard title="Campos VTEX" labels={labels} values={values} />
      )}
      <FixedFooter>
        <ButtonContainerStyled>
          <Button
            isPrimary
            onClick={handleApplyData}
          >
            Aplicar dados
          </Button>
        </ButtonContainerStyled>
      </FixedFooter>
    </CamposContainer>
  );
}
